import React from "react";
import "./styles.css";
import ProfileIcon from "../../../assets/icons/profile.svg";
import { useUserData } from "../../../hooks/useUserData";
import { useLocalization } from "../../../context/LocalizationContext";
import { convertToArabicNumerals } from "../../../utils/helpers";
import { UserData } from "../../../dtos/patient";

const getLocalizedGender = (
  gender: string | null | undefined,
  female: string,
  male: string
): string => (gender?.toLowerCase() === "female" ? female : male);

const getLocalizedAge = (
  age: number | string | null | undefined,
  isRTL: boolean
): string | number => (isRTL ? convertToArabicNumerals(age) : (age ?? ""));

const ProfileSection: React.FC = () => {
  const { userData } = useUserData() as { userData: UserData | null };
  const { t, isRTL } = useLocalization();

  if (!userData) return null;

  return (
    <div className="profile-section">
      <div className="profile-info">
        <h3
          className="profile-name"
          style={{ textAlign: isRTL ? "left" : "right" }}
        >
          {userData.name}
        </h3>
        <p className="profile-details">
          {getLocalizedGender(userData.gender, t("female"), t("male"))},{" "}
          {getLocalizedAge(userData.age, isRTL)} {t("years")}
        </p>
      </div>
      <div className="profile-avatar">
        <img src={ProfileIcon} alt="" />
      </div>
    </div>
  );
};

export default ProfileSection;
